module.exports = __webpack_public_path__ + "img/emoji_freezing_face.87fc0cd9.png";